import { AllTasks } from 'pages/all-tasks';
import { CompleteSignup } from 'pages/complete-signup';
import { Completed } from 'pages/completed';
import { Error } from 'pages/error';
import { ForgotPassword } from 'pages/forgot-password';
import { GoalDetail, GoalDetailRoutes } from 'pages/goal-detail';
import { GoalTemplatesOverview } from 'pages/goal-templates-overview';
import { GoalsOverviewCalendar } from 'pages/goals-overview-calendar';
import { HabitsOverview } from 'pages/habits-overview';
import { Inbox } from 'pages/inbox';
import { Insights } from 'pages/insights';
import { LifeAreaDetail, LifeAreaDetailRoutes } from 'pages/life-area-detail';
import { LifeAreaOverview } from 'pages/life-area-overview';
import { Loading } from 'pages/loading';
import { Login } from 'pages/login';
import { ResetPassword } from 'pages/reset-password';
import { Root } from 'pages/root';
import { Search } from 'pages/search';
import { Signup } from 'pages/signup';
import { TagDetail } from 'pages/tag-detail';
import { TaskCreatePage } from 'pages/task-create';
import { Today } from 'pages/today';
import { Upcoming } from 'pages/upcoming';
import { VerifyEmail } from 'pages/verify-email';
import * as React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import {
  completeSignupLoader,
  loginLoader,
  userLoader,
} from './loaders/user-loader';
import { Paths } from './paths';

const router = createBrowserRouter([
  {
    path: '*',
    element: <Error />,
    errorElement: <Error />,
  },
  {
    path: Paths.Login,
    element: <Login />,
    errorElement: <Error />,
    loader: loginLoader,
  },
  {
    path: Paths.Signup,
    element: <Signup />,
    errorElement: <Error />,
    loader: loginLoader,
  },
  {
    path: Paths.ForgotPassword,
    element: <ForgotPassword />,
    errorElement: <Error />,
  },
  {
    path: Paths.ResetPassword,
    element: <ResetPassword />,
    errorElement: <Error />,
  },
  {
    path: Paths.CompleteSignup,
    element: <CompleteSignup />,
    errorElement: <Error />,
    loader: completeSignupLoader,
  },
  {
    path: Paths.VerifyEmail,
    element: <VerifyEmail />,
    errorElement: <Error />,
  },
  {
    path: Paths.Home,
    element: <Root />,
    errorElement: <Error />,
    children: [
      {
        index: true,
        element: <Today />,
      },
      {
        path: Paths.Inbox,
        element: <Inbox />,
      },
      {
        path: Paths.Upcoming,
        element: <Upcoming />,
      },
      {
        path: Paths.AllTasks,
        element: <AllTasks />,
      },
      {
        path: Paths.Completed,
        element: <Completed />,
      },
      {
        path: Paths.GoalDetail,
        element: <GoalDetail />,
        children: GoalDetailRoutes,
      },
      {
        path: Paths.Goals,
        element: <GoalsOverviewCalendar />,
      },
      {
        path: Paths.GoalTemplates,
        element: <GoalTemplatesOverview />,
      },
      {
        path: Paths.LifeAreas,
        element: <LifeAreaOverview />,
      },
      {
        path: Paths.LifeAreaDetail,
        element: <LifeAreaDetail />,
        children: LifeAreaDetailRoutes,
      },
      {
        path: Paths.Habits,
        element: <HabitsOverview />,
      },
      {
        path: Paths.Insights,
        element: <Insights />,
      },
      {
        path: Paths.TagDetail,
        element: <TagDetail />,
      },
      {
        path: Paths.Search,
        element: <Search />,
      },
    ],
    loader: userLoader,
  },
  {
    path: Paths.TaskCreate,
    element: <TaskCreatePage />,
  },
]);

export const Routes: React.FC = () => (
  <RouterProvider router={router} fallbackElement={<Loading />} />
);
